import styled from "styled-components";

export const Flexed = styled.div<{ $flex?: number }>`
  flex: ${(props) => props.$flex || 1};
`;

export const IdRender = styled.div`
  color: #999;
  font-style: italic;
`;

export const Important = styled.span`
  font-weight: bold;
  color: ${(props) => props.color || "#f40"};
`;

export const fileInput = async ({
  type = "file",
  accept = "image/*",
  multiple = true,
}) =>
  new Promise<FileList>((resolve, reject) => {
    const input = document.createElement("input");
    input.type = type;
    input.accept = accept;
    input.multiple = multiple;
    input.onchange = async (e: Event) => {
      const target = e.target as HTMLInputElement;
      if (!target.files) reject("No files selected");
      else resolve(target.files);
    };
    input.click();
  });
